import { motion } from "framer-motion";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Brain, ArrowLeft, Construction } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SystemDesignMode() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="grid-background min-h-screen">
        <nav className="border-b border-border/50 backdrop-blur-sm bg-background/80">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <Button
                variant="ghost"
                onClick={() => navigate('/dashboard')}
                data-testid="back-button"
                className="flex items-center space-x-2"
              >
                <ArrowLeft className="w-5 h-5" />
                <span>Назад</span>
              </Button>
              <h1 className="text-xl font-bold text-foreground">System Design Challenge</h1>
              <div className="w-24"></div>
            </div>
          </div>
        </nav>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="space-y-8"
          >
            <div className="bg-card/50 backdrop-blur-sm border border-white/5 p-8 rounded-2xl">
              <div className="flex items-center space-x-3 mb-6">
                <Brain className="w-8 h-8 text-primary" />
                <h2 className="text-3xl font-bold text-foreground">Проектування систем</h2>
              </div>
              
              <div className="mt-8 p-6 rounded-xl bg-secondary/10 border border-secondary/30">
                <div className="flex items-start space-x-3">
                  <Construction className="w-6 h-6 text-secondary flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-lg font-bold text-foreground mb-2">Режим в розробці</h3>
                    <p className="text-muted-foreground">
                      Цей режим дозволить вам проектувати комплексні системи з нуля, обираючи архітектурний стиль, бази даних та стратегії масштабування. Повна версія незабаром!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}